<div class="spell-check-suggestion-popover">
  <div class="popover-header">
    <span class="original-word">"{{ originalWord }}"</span>
    <button class="close-btn" (click)="close()" title="Close">
      <i class="mdi mdi-close"></i>
    </button>
  </div>

  <div class="popover-body">
    @if (suggestions && suggestions.length > 0) {
      <div class="suggestions-section">
        <div class="section-label">Suggestions:</div>
        <div class="suggestion-list">
          @for (suggestion of suggestions; track suggestion) {
            <button
              class="suggestion-item"
              (mousedown)="selectSuggestion($event, suggestion)"
              type="button">
              {{ suggestion }}
            </button>
          }
        </div>
      </div>
    }

    @if (!suggestions || suggestions.length === 0) {
      <div class="no-suggestions">
        No suggestions available
      </div>
    }
  </div>
</div>
